import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-remote-camera-session-dialog',
  templateUrl: './remote-camera-session-dialog.component.html',
  styleUrls: ['./remote-camera-session-dialog.component.scss']
})
export class RemoteCameraSessionDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: RemoteCameraDialogModel,
    private matDialogRef: MatDialogRef<RemoteCameraSessionDialogComponent>) {
  }
  public showEmailItemList = false;
  public isEmailControlTouched = false;

  public resultModel: RemoteCameraResultgModel = { email: '' };

  ngOnInit(): void {    
    if(this.data && this.data.workOrder){
      this.resultModel.workOrder = this.data.workOrder;
    }
  }
  outSideClicked() {
    if (this.showEmailItemList) {
      this.closeEmailSelect();
    }
  }
  toggleEmailItemList() {
    this.showEmailItemList = !this.showEmailItemList;
  }
  closeEmailSelect() {
    this.showEmailItemList = false;
  }
  setEmail(email: string) {
    this.resultModel.email = email;
   this.closeEmailSelect();
  }
  blurEvent() {
    setTimeout(() => {
      this.isEmailControlTouched = true;
    }, 100)

  }
  initiateCameraSession(){
    this.matDialogRef.close(this.resultModel); 
  }
  cancel() {
    this.matDialogRef.close();
  }
}

export interface RemoteCameraDialogModel {
  mailList: Array<string>,
  deviceId: string,
  customer: string,
  lab: string,
  workOrder: string
}
export interface RemoteCameraResultgModel {
  email: string
  workOrder?: string,
  remarks?: string
}